import { useEffect, useState } from "react";
import {
    Collapse,
    ListGroup,
    ListGroupItem,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    Nav,
    NavItem,
    NavLink,
    Tooltip,
    Container,
} from "reactstrap";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CodeIcon from "@mui/icons-material/Code";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import EngineeringIcon from "@mui/icons-material/Engineering";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import GavelIcon from "@mui/icons-material/Gavel";
import CallIcon from "@mui/icons-material/Call";

import "./NavHeader.css";

function NavHeader() {

    /* =========================================================
       MAIN NAVBAR
    ========================================================= */

    const [isOpen, setIsOpen] = useState(false);

    /* =========================================================
       DESKTOP TOOLTIP STATES
    ========================================================= */

    const [coursesOpen, setCoursesOpen] = useState(false);
    const [projectsOpen, setProjectsOpen] = useState(false);
    const [cadOpen, setCadOpen] = useState(false);
    const [policyOpen, setPolicyOpen] = useState(false);

    /* =========================================================
       CAD DESKTOP NESTED STATES
    ========================================================= */

    const [cadCoursesOpen, setCadCoursesOpen] = useState(false);
    const [plmCoursesOpen, setPlmCoursesOpen] = useState(false);

    /* =========================================================
       MOBILE STATES
    ========================================================= */

    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" && window.innerWidth <= 991
    );

    const [mobileCoursesOpen, setMobileCoursesOpen] = useState(false);
    const [mobileProjectsOpen, setMobileProjectsOpen] = useState(false);
    const [mobileCadOpen, setMobileCadOpen] = useState(false);
    const [mobilePolicyOpen, setMobilePolicyOpen] = useState(false);

    const [mobileCadCoursesOpen, setMobileCadCoursesOpen] = useState(false);
    const [mobilePlmCoursesOpen, setMobilePlmCoursesOpen] = useState(false);

    /* =========================================================
       RESPONSIVE CHECK
    ========================================================= */

    useEffect(() => {

        const handleResize = () => {

            const mobile = window.innerWidth <= 991;

            setIsMobile(mobile);

            if (!mobile) {

                setMobileCoursesOpen(false);
                setMobileProjectsOpen(false);
                setMobileCadOpen(false);
                setMobilePolicyOpen(false);

                setMobileCadCoursesOpen(false);
                setMobilePlmCoursesOpen(false);
            }

        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };

    }, []);

    /* =========================================================
       MAIN NAVBAR TOGGLE
    ========================================================= */

    const toggle = () => {

        setIsOpen((prev) => !prev);

    };

    /* =========================================================
       CLOSE MOBILE MENUS
    ========================================================= */

    const closeMobileMenus = () => {

        setMobileCoursesOpen(false);
        setMobileProjectsOpen(false);
        setMobileCadOpen(false);
        setMobilePolicyOpen(false);

        setMobileCadCoursesOpen(false);
        setMobilePlmCoursesOpen(false);

    };

    /* =========================================================
       MOBILE MAIN MENU HELPERS
    ========================================================= */

    const toggleMobileCourses = () => {

        setMobileCoursesOpen((prev) => !prev);

        setMobileProjectsOpen(false);
        setMobileCadOpen(false);
        setMobilePolicyOpen(false);

        setMobileCadCoursesOpen(false);
        setMobilePlmCoursesOpen(false);

    };

    const toggleMobileProjects = () => {

        setMobileProjectsOpen((prev) => !prev);

        setMobileCoursesOpen(false);
        setMobileCadOpen(false);
        setMobilePolicyOpen(false);

        setMobileCadCoursesOpen(false);
        setMobilePlmCoursesOpen(false);

    };

    const toggleMobileCad = () => {

        setMobileCadOpen((prev) => !prev);

        setMobileCoursesOpen(false);
        setMobileProjectsOpen(false);
        setMobilePolicyOpen(false);

        setMobileCadCoursesOpen(false);
        setMobilePlmCoursesOpen(false);

    };

    const toggleMobilePolicy = () => {

        setMobilePolicyOpen((prev) => !prev);

        setMobileCoursesOpen(false);
        setMobileProjectsOpen(false);
        setMobileCadOpen(false);

        setMobileCadCoursesOpen(false);
        setMobilePlmCoursesOpen(false);

    };

    /* =========================================================
       MOBILE CAD SUBMENUS
    ========================================================= */

    const toggleMobileCadCourses = () => {

        setMobileCadCoursesOpen((prev) => !prev);

        setMobilePlmCoursesOpen(false);

    };

    const toggleMobilePlmCourses = () => {

        setMobilePlmCoursesOpen((prev) => !prev);

        setMobileCadCoursesOpen(false);

    };

    return (
        <Container className="fw-navbar">

            <Navbar expand="lg">

                {/* =================================================
                    BRAND
                ================================================== */}

                <NavbarBrand
                    href="/"
                    className="fw-brand"
                    onClick={closeMobileMenus}
                >

                    <span className="fw-logo">

                        <img
                            src="/Fees_logo.webp"
                            alt="FeesWorth Online Training"
                            className="hero-logo"
                        />

                    </span>

                    <span className="fw-brand-name">

                         ees<span>Worth</span>

                    </span>

                </NavbarBrand>


                {/* =================================================
                    MOBILE TOGGLER
                ================================================== */}

                <NavbarToggler
                    onClick={toggle}
                    className="fw-toggler"
                >

                    <span></span>
                    <span></span>
                    <span></span>

                </NavbarToggler>


                <Collapse isOpen={isOpen} navbar>

                    <Nav className="fw-nav ms-auto" navbar>

                        {/* =================================================
                            HOME
                        ================================================== */}

                        <NavItem>

                            <NavLink
                                href="/"
                                className="fw-nav-link fw-active"
                                onClick={closeMobileMenus}
                            >
                                Home
                            </NavLink>

                        </NavItem>


                        {/* =================================================
                            AI ML COURSES
                        ================================================== */}

                        <NavItem className="fw-tooltip-wrapper">

                            <NavLink
                                id="aiCourses"
                                href="#"
                                className="fw-nav-link"
                                onMouseEnter={() => {
                                    if (!isMobile) {
                                        setCoursesOpen(true);
                                    }
                                }}
                                onClick={(e) => {

                                    e.preventDefault();

                                    if (isMobile) {
                                        toggleMobileCourses();
                                    } else {
                                        setCoursesOpen((prev) => !prev);
                                    }

                                }}
                            >

                                AI ML Courses

                                <ArrowDropDownIcon
                                    className={
                                        isMobile && mobileCoursesOpen
                                            ? "fw-arrow fw-arrow-mobile-open"
                                            : "fw-arrow"
                                    }
                                />

                            </NavLink>


                            {/* =================================================
                                MOBILE AI COURSES
                            ================================================== */}

                            {isMobile && mobileCoursesOpen && (

                                <div className="fw-mobile-dropdown">

                                    <a href="/python-courses-pay-after-learn">

                                        <CodeIcon />

                                        <div>
                                            <strong>
                                                Python Programming
                                            </strong>

                                            <span>
                                                Learn Python from fundamentals to advanced
                                            </span>
                                        </div>

                                    </a>


                                    <a href="/ai-courses-pay-after-learn">

                                        <SmartToyIcon />

                                        <div>
                                            <strong>
                                                Artificial Intelligence
                                            </strong>

                                            <span>
                                                AI concepts, models and applications
                                            </span>
                                        </div>

                                    </a>


                                    <a href="/machine-learning-courses-pay-after-learn">

                                        <PsychologyIcon />

                                        <div>
                                            <strong>
                                                Machine Learning
                                            </strong>

                                            <span>
                                                Algorithms, models and real-world ML
                                            </span>
                                        </div>

                                    </a>


                                    <a href="/data-science-courses-pay-after-learn">

                                        <AccountTreeIcon />

                                        <div>
                                            <strong>
                                                Data Science
                                            </strong>

                                            <span>
                                                Data analysis, visualization and modeling
                                            </span>
                                        </div>

                                    </a>


                                    <a
                                        href="/best-online-courses"
                                        className="fw-mobile-view-all"
                                    >
                                        <span>
                                            View all courses
                                        </span>

                                        <span>
                                            →
                                        </span>
                                    </a>

                                </div>

                            )}


                            {/* =================================================
                                DESKTOP AI COURSES
                            ================================================== */}

                            {!isMobile && (

                                <Tooltip
                                    isOpen={coursesOpen}
                                    target="aiCourses"
                                    placement="bottom"
                                    toggle={() =>
                                        setCoursesOpen((prev) => !prev)
                                    }
                                    className="fw-tooltip"
                                    autohide={false}
                                >

                                    <div
                                        onMouseLeave={() =>
                                            setCoursesOpen(false)
                                        }
                                        className="fw-tooltip-content"
                                    >

                                        <ListGroup className="fw-tooltip-list mt-4">

                                            <ListGroupItem
                                                tag="a"
                                                href="/python-courses-pay-after-learn"
                                                className="fw-tooltip-item"
                                            >

                                                <CodeIcon />

                                                <div>

                                                    <strong>
                                                        Python Programming
                                                    </strong>

                                                    <span>
                                                        Learn Python from fundamentals to advanced
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/ai-courses-pay-after-learn"
                                                className="fw-tooltip-item"
                                            >

                                                <SmartToyIcon />

                                                <div>

                                                    <strong>
                                                        Artificial Intelligence
                                                    </strong>

                                                    <span>
                                                        AI concepts, models and applications
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/machine-learning-courses-pay-after-learn"
                                                className="fw-tooltip-item"
                                            >

                                                <PsychologyIcon />

                                                <div>

                                                    <strong>
                                                        Machine Learning
                                                    </strong>

                                                    <span>
                                                        Algorithms, models and real-world ML
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/data-science-courses-pay-after-learn"
                                                className="fw-tooltip-item"
                                            >

                                                <AccountTreeIcon />

                                                <div>

                                                    <strong>
                                                        Data Science
                                                    </strong>

                                                    <span>
                                                        Data analysis, visualization and modeling
                                                    </span>

                                                </div>

                                            </ListGroupItem>

                                        </ListGroup>


                                        <div className="fw-tooltip-footer">

                                            <a href="/best-online-courses">

                                                View all courses

                                                <span>
                                                    →
                                                </span>

                                            </a>

                                        </div>

                                    </div>

                                </Tooltip>

                            )}

                        </NavItem>


                        {/* =================================================
                            AI ML PROJECTS
                        ================================================== */}

                        <NavItem className="fw-tooltip-wrapper">

                            <NavLink
                                id="aiProjects"
                                href="#"
                                className="fw-nav-link"
                                onMouseEnter={() => {

                                    if (!isMobile) {
                                        setProjectsOpen(true);
                                    }

                                }}
                                onClick={(e) => {

                                    e.preventDefault();

                                    if (isMobile) {
                                        toggleMobileProjects();
                                    } else {
                                        setProjectsOpen((prev) => !prev);
                                    }

                                }}
                            >

                                AI ML Projects

                                <ArrowDropDownIcon
                                    className={
                                        isMobile && mobileProjectsOpen
                                            ? "fw-arrow fw-arrow-mobile-open"
                                            : "fw-arrow"
                                    }
                                />

                            </NavLink>


                            {/* =================================================
                                MOBILE AI PROJECTS
                            ================================================== */}

                            {isMobile && mobileProjectsOpen && (

                                <div className="fw-mobile-dropdown">

                                    <a href="/ai-ml-project-rag-retrieval-argument-generation">

                                        <SmartToyIcon />

                                        <div>

                                            <strong>
                                                RAG
                                            </strong>

                                            <span>
                                                Retrieval Augmented Generation
                                            </span>

                                        </div>

                                    </a>


                                    <a href="/ai-ml-project-brain-stroke-prediction-opencv-cnn">

                                        <PsychologyIcon />

                                        <div>

                                            <strong>
                                                Brain Stroke Prediction
                                            </strong>

                                            <span>
                                                AI-based healthcare prediction
                                            </span>

                                        </div>

                                    </a>


                                    <a href="/ai-ml-project-intelligent-manufacturing-quality-control-system">

                                        <EngineeringIcon />

                                        <div>

                                            <strong>
                                                Intelligent Manufacturing
                                            </strong>

                                            <span>
                                                AI-powered quality control
                                            </span>

                                        </div>

                                    </a>


                                    <a href="/replace-it-help-desk-with-automated-ticketing-system-using-ai">

                                        <SmartToyIcon />

                                        <div>

                                            <strong>
                                                Automated IT Ticketing
                                            </strong>

                                            <span>
                                                AI-powered help desk automation
                                            </span>

                                        </div>

                                    </a>


                                    <a href="/ai-ml-project-image-classification-deep-learning">

                                        <AccountTreeIcon />

                                        <div>

                                            <strong>
                                                Image Classification
                                            </strong>

                                            <span>
                                                Computer vision using AI
                                            </span>

                                        </div>

                                    </a>

                                </div>

                            )}


                            {/* =================================================
                                DESKTOP AI PROJECTS
                            ================================================== */}

                            {!isMobile && (

                                <Tooltip
                                    isOpen={projectsOpen}
                                    target="aiProjects"
                                    placement="bottom"
                                    toggle={() =>
                                        setProjectsOpen((prev) => !prev)
                                    }
                                    className="fw-tooltip"
                                    autohide={false}
                                >

                                    <div
                                        onMouseLeave={() =>
                                            setProjectsOpen(false)
                                        }
                                        className="fw-tooltip-content"
                                    >

                                        <ListGroup className="fw-tooltip-list mt-3">

                                            <ListGroupItem
                                                tag="a"
                                                href="/ai-ml-project-rag-retrieval-argument-generation"
                                                className="fw-tooltip-item"
                                            >

                                                <SmartToyIcon />

                                                <div>

                                                    <strong>
                                                        RAG
                                                    </strong>

                                                    <span>
                                                        Retrieval Augmented Generation
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/ai-ml-project-brain-stroke-prediction-opencv-cnn"
                                                className="fw-tooltip-item"
                                            >

                                                <PsychologyIcon />

                                                <div>

                                                    <strong>
                                                        Brain Stroke Prediction
                                                    </strong>

                                                    <span>
                                                        AI-based healthcare prediction
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/ai-ml-project-intelligent-manufacturing-quality-control-system"
                                                className="fw-tooltip-item"
                                            >

                                                <EngineeringIcon />

                                                <div>

                                                    <strong>
                                                        Intelligent Manufacturing
                                                    </strong>

                                                    <span>
                                                        AI-powered quality control
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/replace-it-help-desk-with-automated-ticketing-system-using-ai"
                                                className="fw-tooltip-item"
                                            >

                                                <SmartToyIcon />

                                                <div>

                                                    <strong>
                                                        Automated IT Ticketing
                                                    </strong>

                                                    <span>
                                                        AI-powered help desk automation
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/ai-ml-project-image-classification-deep-learning"
                                                className="fw-tooltip-item"
                                            >

                                                <AccountTreeIcon />

                                                <div>

                                                    <strong>
                                                        Image Classification
                                                    </strong>

                                                    <span>
                                                        Computer vision using AI
                                                    </span>

                                                </div>

                                            </ListGroupItem>

                                        </ListGroup>

                                    </div>

                                </Tooltip>

                            )}

                        </NavItem>


                        {/* =================================================
                            CAD & PLM AUTOMATION
                        ================================================== */}

                        <NavItem className="fw-tooltip-wrapper">

                            <NavLink
                                id="cadAutomation"
                                href="#"
                                className="fw-nav-link"
                                onMouseEnter={() => {

                                    if (!isMobile) {
                                        setCadOpen(true);
                                    }

                                }}
                                onClick={(e) => {

                                    e.preventDefault();

                                    if (isMobile) {
                                        toggleMobileCad();
                                    } else {
                                        setCadOpen((prev) => !prev);
                                    }

                                }}
                            >

                                CAD & PLM Automation

                                <ArrowDropDownIcon
                                    className={
                                        isMobile && mobileCadOpen
                                            ? "fw-arrow fw-arrow-mobile-open"
                                            : "fw-arrow"
                                    }
                                />

                            </NavLink>


                            {/* =================================================
                                MOBILE CAD / PLM
                            ================================================== */}

                            {isMobile && mobileCadOpen && (

                                <div className="fw-mobile-dropdown fw-mobile-cad">

                                    {/* =================================================
                                        CAD AUTOMATION
                                    ================================================== */}

                                    <div className="fw-mobile-parent">

                                        <button
                                            type="button"
                                            className="fw-mobile-parent-btn"
                                            onClick={toggleMobileCadCourses}
                                        >

                                            <div className="fw-mobile-parent-content">

                                                <EngineeringIcon />

                                                <div>

                                                    <strong>
                                                        CAD Automation & Customization Courses
                                                    </strong>

                                                    <span>
                                                        CAD customization & automation
                                                    </span>

                                                </div>

                                            </div>


                                            <ArrowDropDownIcon
                                                className={
                                                    mobileCadCoursesOpen
                                                        ? "fw-mobile-arrow-open"
                                                        : ""
                                                }
                                            />

                                        </button>


                                        {mobileCadCoursesOpen && (

                                            <div className="fw-mobile-submenu">

                                                {/* <a href="/cad-automation-training">
                                                    CAD Automation Training
                                                </a> */}

                                                <a href="/nx-open-customization-automation-training">
                                                    NX Open Customization & Automation Training
                                                </a>

                                                <a href="/catia-caa-customization-automation-training">
                                                    CATIA CAA Customization & Automation Training
                                                </a>

                                                <a href="/python-catia-automation-customization">
                                                    Python CATIA Automation and Customization
                                                </a>

                                                <a href="/creo-toolkit-customization-training">
                                                    CREO Toolkit Customization & Automation Training
                                                </a>

                                                <a href="/solidworks-api-customization-automation-training">
                                                    SolidWorks API Customization & Automation Training
                                                </a>

                                                <a href="/autocad-api-customization-automation-online-courses">
                                                    AutoCAD .NET API Automation Training (2026)
                                                </a>

                                                <a href="/autodesk-revit-api-customization-automation-course">
                                                    Autodesk Revit API Customization & Automation Course
                                                </a>

                                                <a href="/autodesk-inventor-api-customization-automation-course">
                                                    Autodesk Inventor API Customization & Automation Course
                                                </a>

                                            </div>

                                        )}

                                    </div>


                                    {/* =================================================
                                        PLM AUTOMATION
                                    ================================================== */}

                                    <div className="fw-mobile-parent">

                                        <button
                                            type="button"
                                            className="fw-mobile-parent-btn"
                                            onClick={toggleMobilePlmCourses}
                                        >

                                            <div className="fw-mobile-parent-content">

                                                <AccountTreeIcon />

                                                <div>

                                                    <strong>
                                                        PLM Automation Courses
                                                    </strong>

                                                    <span>
                                                        Enterprise PLM customization
                                                    </span>

                                                </div>

                                            </div>


                                            <ArrowDropDownIcon
                                                className={
                                                    mobilePlmCoursesOpen
                                                        ? "fw-mobile-arrow-open"
                                                        : ""
                                                }
                                            />

                                        </button>


                                        {mobilePlmCoursesOpen && (

                                            <div className="fw-mobile-submenu">

                                                <a href="/teamcenter-plm-customization-training-itk-rac-soa-awc">
                                                    Teamcenter PLM Customization
                                                </a>

                                                <a href="/ptc-windchill-plm-customization-course">
                                                    PTC Windchill PLM Customization
                                                </a>

                                            </div>

                                        )}

                                    </div>

                                </div>

                            )}


                            {/* =================================================
                                DESKTOP CAD
                            ================================================== */}

                            {!isMobile && (

                                <Tooltip
                                    isOpen={cadOpen}
                                    target="cadAutomation"
                                    placement="bottom"
                                    toggle={() =>
                                        setCadOpen((prev) => !prev)
                                    }
                                    className="fw-tooltip fw-cad-tooltip"
                                    autohide={false}
                                >

                                    <div
                                        className="fw-tooltip-content fw-cad-dropdown"
                                        onMouseLeave={() => {

                                            setCadOpen(false);
                                            setCadCoursesOpen(false);
                                            setPlmCoursesOpen(false);

                                        }}
                                    >

                                        <ListGroup className="fw-tooltip-list">


                                            {/* =================================================
                                                CAD AUTOMATION
                                            ================================================== */}

                                            <div
                                                className={`fw-tooltip-item fw-cad-parent ${
                                                    cadCoursesOpen
                                                        ? "fw-cad-parent-active"
                                                        : ""
                                                }`}
                                                onMouseEnter={() => {

                                                    setCadCoursesOpen(true);
                                                    setPlmCoursesOpen(false);

                                                }}
                                            >

                                                <div className="fw-cad-parent-left">

                                                    <EngineeringIcon />

                                                    <a
                                                        href="/cad-automation-training"
                                                        className="fw-cad-parent-link"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >

                                                        <div>

                                                            <strong>
                                                                CAD Automation & Customization Courses
                                                            </strong>

                                                           
                                                        </div>

                                                    </a>

                                                </div>


                                                <span className="fw-cad-right-arrow">
                                                    ›
                                                </span>


                                                {cadCoursesOpen && (

                                                    <div
                                                        className="fw-cad-submenu"
                                                        onMouseEnter={() => {

                                                            setCadCoursesOpen(true);
                                                            setCadOpen(true);

                                                        }}
                                                    >

                                                        {/* <a
                                                            href="/cad-automation-training"
                                                            className="fw-cad-submenu-header"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <span>
                                                                CAD Automation Training
                                                            </span>
                                                        </a> */}


                                                        <a href="/nx-open-customization-automation-training">
                                                            NX Open Customization & Automation Training
                                                        </a>


                                                        <a href="/catia-caa-customization-automation-training">
                                                            CATIA CAA Customization & Automation Training
                                                        </a>


                                                        <a href="/python-catia-automation-customization">
                                                            Python CATIA Automation and Customization
                                                        </a>


                                                        <a href="/creo-toolkit-customization-training">
                                                            CREO Toolkit Customization & Automation Training
                                                        </a>


                                                        <a href="/solidworks-api-customization-automation-training">
                                                            SolidWorks API Customization & Automation Training
                                                        </a>


                                                        <a href="/autocad-api-customization-automation-online-courses">
                                                            AutoCAD .NET API Automation Training (2026)
                                                        </a>


                                                        <a href="/autodesk-revit-api-customization-automation-course">
                                                            Autodesk Revit API Customization & Automation Course
                                                        </a>


                                                        <a href="/autodesk-inventor-api-customization-automation-course">
                                                            Autodesk Inventor API Customization & Automation Course
                                                        </a>

                                                    </div>

                                                )}

                                            </div>


                                            {/* =================================================
                                                PLM AUTOMATION
                                            ================================================== */}

                                            <div
                                                className={`fw-tooltip-item fw-cad-parent ${
                                                    plmCoursesOpen
                                                        ? "fw-cad-parent-active"
                                                        : ""
                                                }`}
                                                onMouseEnter={() => {

                                                    setPlmCoursesOpen(true);
                                                    setCadCoursesOpen(false);

                                                }}
                                            >

                                                <div className="fw-cad-parent-left">

                                                    <AccountTreeIcon />

                                                    <div>

                                                        <strong>
                                                            PLM Automation Courses
                                                        </strong>

                                                        <span>
                                                            Enterprise PLM customization
                                                        </span>

                                                    </div>

                                                </div>


                                                <span className="fw-cad-right-arrow">
                                                    ›
                                                </span>


                                                {plmCoursesOpen && (

                                                    <div
                                                        className="fw-cad-submenu"
                                                        onMouseEnter={() => {

                                                            setPlmCoursesOpen(true);
                                                            setCadOpen(true);

                                                        }}
                                                    >

                                                        <span className="fw-cad-submenu-header">
                                                            PLM Automation Courses
                                                        </span>


                                                        <a href="/teamcenter-plm-customization-training-itk-rac-soa-awc">
                                                            Teamcenter PLM Customization
                                                        </a>


                                                        <a href="/ptc-windchill-plm-customization-course">
                                                            PTC Windchill PLM Customization
                                                        </a>

                                                    </div>

                                                )}

                                            </div>

                                        </ListGroup>

                                    </div>

                                </Tooltip>

                            )}

                        </NavItem>


                        {/* =================================================
                            POLICY
                        ================================================== */}

                        <NavItem className="fw-tooltip-wrapper">

                            <NavLink
                                id="policy"
                                href="#"
                                className="fw-nav-link"
                                onMouseEnter={() => {

                                    if (!isMobile) {
                                        setPolicyOpen(true);
                                    }

                                }}
                                onClick={(e) => {

                                    e.preventDefault();

                                    if (isMobile) {
                                        toggleMobilePolicy();
                                    } else {
                                        setPolicyOpen((prev) => !prev);
                                    }

                                }}
                            >

                                Policy

                                <ArrowDropDownIcon
                                    className={
                                        isMobile && mobilePolicyOpen
                                            ? "fw-arrow fw-arrow-mobile-open"
                                            : "fw-arrow"
                                    }
                                />

                            </NavLink>


                            {/* =================================================
                                MOBILE POLICY
                            ================================================== */}

                            {isMobile && mobilePolicyOpen && (

                                <div className="fw-mobile-dropdown">

                                    <a href="/privacy-policy">

                                        <PrivacyTipIcon />

                                        <div>

                                            <strong>
                                                Privacy Policy
                                            </strong>

                                            <span>
                                                How we handle your information
                                            </span>

                                        </div>

                                    </a>


                                    <a href="/terms-conditions">

                                        <GavelIcon />

                                        <div>

                                            <strong>
                                                Terms & Conditions
                                            </strong>

                                            <span>
                                                Website terms and usage
                                            </span>

                                        </div>

                                    </a>

                                </div>

                            )}


                            {/* =================================================
                                DESKTOP POLICY
                            ================================================== */}

                            {!isMobile && (

                                <Tooltip
                                    isOpen={policyOpen}
                                    target="policy"
                                    placement="bottom"
                                    toggle={() =>
                                        setPolicyOpen((prev) => !prev)
                                    }
                                    className="fw-tooltip"
                                    autohide={false}
                                >

                                    <div
                                        onMouseLeave={() =>
                                            setPolicyOpen(false)
                                        }
                                        className="fw-tooltip-content"
                                    >

                                        <ListGroup className="fw-tooltip-list mt-3">

                                            <ListGroupItem
                                                tag="a"
                                                href="/privacy-policy"
                                                className="fw-tooltip-item"
                                            >

                                                <PrivacyTipIcon />

                                                <div>

                                                    <strong>
                                                        Privacy Policy
                                                    </strong>

                                                    <span>
                                                        How we handle your information
                                                    </span>

                                                </div>

                                            </ListGroupItem>


                                            <ListGroupItem
                                                tag="a"
                                                href="/terms-conditions"
                                                className="fw-tooltip-item"
                                            >

                                                <GavelIcon />

                                                <div>

                                                    <strong>
                                                        Terms & Conditions
                                                    </strong>

                                                    <span>
                                                        Website terms and usage
                                                    </span>

                                                </div>

                                            </ListGroupItem>

                                        </ListGroup>

                                    </div>

                                </Tooltip>

                            )}

                        </NavItem>


                        {/* =================================================
                            CONTACT
                        ================================================== */}

                        <NavItem className="fw-contact-wrapper">

                            <NavLink
                                href="/contact"
                                className="fw-contact-btn"
                                onClick={closeMobileMenus}
                            >

                                <CallIcon />

                                Contact

                            </NavLink>

                        </NavItem>

                    </Nav>

                </Collapse>

            </Navbar>

        </Container>
    );
}

export default NavHeader;